import { GET, POST } from "../components/constants/request-type";
import { service_api } from "../components/constants/url";
import { MakeRequestAsync } from "../components/functions/axios";
import { createLogger } from "../utils/logger";

const logger = createLogger("BankingService");

class BankingService {
  async startOnboarding(userId, token) {
    try {
      const response = await MakeRequestAsync({
        type: POST,
        url: service_api,
        route: `stripe-connect/onboard/${userId}`,
        token
      });
      return response.data;
    } catch (error) {
      logger.error("Failed to start onboarding:", error);
      throw error;
    }
  }

  async verifyAccount(userId, token) {
    try {
      const response = await MakeRequestAsync({
        type: GET,
        url: service_api,
        route: `stripe-connect/verify/${userId}`,
        token
      });
      return response.data;
    } catch (error) {
      logger.error("Failed to verify account:", error);
      throw error;
    }
  }

  async getRequirements(userId, token) {
    try {
      const response = await MakeRequestAsync({
        type: GET,
        url: service_api,
        route: `stripe-connect/requirements/${userId}`,
        token
      });
      return response.data;
    } catch (error) {
      logger.error("Failed to get requirements:", error);
      throw error;
    }
  }

  async checkVerification(userId, verificationType, token) {
    try {
      const response = await MakeRequestAsync({
        type: GET,
        url: service_api,
        route: `stripe-connect/check/${userId}/${verificationType}`,
        token
      });
      return response.data;
    } catch (error) {
      logger.error("Failed to check verification:", error);
      throw error;
    }
  }
}

export const bankingService = new BankingService();
